import React from "react";
import { Image } from 'react-bootstrap';
import HTMLReactParser from "html-react-parser";

export default function Pavan({links, pavanLink, swmcLink,angelAiLink}) {
    return (
        <>
            <div>
                <div className="wave-mobile">
                    <Image loading="lazy" src={`${process.env.REACT_APP_ROCKSTARS_CDN_IMAGES}wave-mobile.png`} width="420px" height="" className="ta-podcast-wave-blue" />
                </div>
                <div className="Pavan">
                    <div>
                        {HTMLReactParser(pavanLink)}, CEO of {HTMLReactParser(swmcLink)}, explains how {HTMLReactParser(angelAiLink)}, Sun West's super Ai, is redefining how realtors can use Ai to get easy financing for their buyers. Pavan also shares his experience working at a young age with his parents who are real estate agents and what made him a successful real estate investor. He shares valuable tips for homebuyers to make successful real estate investments. Pavan also shares the invaluable golden rules of every successful realtor®,
                        listing and selling agents.
                    </div><br />
                    <div>
                        This is a podcast you cannot afford to miss!
                    </div>
                </div>
                <Image src={`${process.env.REACT_APP_ROCKSTARS_CDN_IMAGES}pavan-bg.webp`} width="420px" height="" className="pavan-bg-img" />
            </div>
        </>
    );
}